import type {ActionReducerMapBuilder} from '@reduxjs/toolkit';
import type {TemplateSubmissionFlowReducerState} from '@Components/template-submission-flow/template-submission-flow.types';
import {SubmissionFlowStep} from '@Components/template-submission-flow/template-submission-flow.types';
import {submitTemplate} from '@Components/template-submission-flow/template-submission-flow-thunk';

export const templateSubmissionFlowExtraReducers = (builder: ActionReducerMapBuilder<TemplateSubmissionFlowReducerState>): void => {
  builder.addCase(submitTemplate.fulfilled, (state) => {
    state.isSubmitting = false;
    state.currentStep = SubmissionFlowStep.IN_REVIEW;
    state.nextStep = SubmissionFlowStep.IN_REVIEW;
  });
  builder.addCase(submitTemplate.pending, (state) => {
    state.isSubmitting = true;
  });
  builder.addCase(submitTemplate.rejected, (state) => {
    state.isSubmitting = false;
  });
};
